export function InventoryLoading({ label = "Loading..." }: { label?: string }) {
  return <div className="rounded-2xl border bg-white p-6 text-sm text-slate-500 shadow-sm">{label}</div>;
}
export function InventoryError({ message }: { message: string }) {
  return <div className="rounded-2xl border border-red-200 bg-red-50 p-6 text-sm text-red-700">{message}</div>;
}
export function InventoryEmpty({ message = "No records found." }: { message?: string }) {
  return <div className="rounded-2xl border bg-white p-10 text-center text-sm text-slate-500 shadow-sm">{message}</div>;
}
